<template>
  <v-layout id="step-1-box" align-center column>
    <TextContent
      :title="title"
      font-size-title="display-33"
      :show-title="true"
      class="content-alignment"
    />
    <p class="display-18">
      כבר נרשמתם? אז רק
      <span class="pointer-underline" @click="openLogin">תתחברו</span>
    </p>
    <SmartAgentForm />
  </v-layout>
</template>

<script>
import TextContent from '@/components/Wrappers/Text/Text'
import SmartAgentForm from '@/components/Smart_Agent/Smart_Agent_Form/SmartAgentForm'
import { mapGetters } from 'vuex'
import gtm from '@/lib/gtm'

export default {
  components: {
    TextContent,
    SmartAgentForm
  },

  data() {
    return {
      title: 'רישום מהיר',
      text:
        'יש לך כבר רישום בדרושים? <span class="pointer-underline " @click.native="openLogin">התחברות</span>'
    }
  },
  computed: {
    ...mapGetters(['isLogged'])
  },

  mounted() {
    if (!this.isLogged) {

      /** Goal 5 event #1 - hit step1 not logged in */

      gtm({
        page: '/smartalerts/step1',
        event: 'smartalert'
      })
    }
  },
  methods: {
    openLogin() {
      document.querySelector('.login-btn').click()
    }
  }
}
</script>

<style lang="scss" scoped>
#step-1-box {
  max-width: 800px;
  margin: 0 auto;
}
.content-alignment {
  display: flex;
  flex-direction: column;
  text-align: center;
}
</style>
